import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageSubscribers } from "../components/Subscribers/ManageSubscribers";

export const SubscribersManage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageSubscribers />
        </div>
      </div>
    </div>
  );
};
